import { Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "../context/AuthContext";
import secureLocalStorage from "react-secure-storage";

const ProtectedRoute = ({ children }) => {
  return (
    <AuthProviderWrapper>
      <ProtectedContent>{children}</ProtectedContent>
    </AuthProviderWrapper>
  );
};

const AuthProviderWrapper = ({ children }) => {
  return <AuthProvider>{children}</AuthProvider>;
};

const ProtectedContent = ({ children }) => {
  const { user, loading } = useAuth();

  
  if (!secureLocalStorage.getItem("token") || !secureLocalStorage.getItem("user")) {
	  return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;